export default __webpack_public_path__ + "static/media/WarningBlackIcon.72527b60.svg";